/**
 * Aggregates different sizes (transfer, encoded body and decoded body) to be later reported in CMAG.
 * In most browsers data might not be available, thus checking for presence and falling back to undefined when not there.
 */
export function sumResourceSizes(entries) {
    if (!entries) {
        return;
    }
    return entries.reduce((agg, entry) => {
        return {
            transferSize: entry.transferSize
                ? agg.transferSize + entry.transferSize
                : agg.transferSize,
            encodedBodySize: entry.encodedBodySize
                ? agg.encodedBodySize + entry.encodedBodySize
                : agg.encodedBodySize,
            decodedBodySize: entry.decodedBodySize
                ? agg.decodedBodySize + entry.decodedBodySize
                : agg.decodedBodySize,
        };
    }, {
        transferSize: 0,
        encodedBodySize: 0,
        decodedBodySize: 0,
    });
}
export const onResourceSize = (callback) => {
    window.addEventListener('load', () => {
        if (performance) {
            // Reporting overall size for different kids of resources
            // to be later analysed in CMAG. Here are some things which this data can help investigate:
            // - broken gzip
            // - started loading too many images
            // - images are too large
            // - additional javascript is loaded
            // - js/css minification is broken
            const resourceEntries = performance.getEntriesByType('resource');
            const navigationEntries = performance.getEntriesByType('navigation');
            const { cssEntries, jsEntries, imageEntries } = resourceEntries.reduce((sum, entry) => {
                if (/[.]css(?:\?|$)/.test(entry.name)) {
                    sum.cssEntries.push(entry);
                    return sum;
                }
                if (/[.]js(?:\?|$)/.test(entry.name)) {
                    sum.jsEntries.push(entry);
                    return sum;
                }
                if (/[.](jpg|jpeg|svg|gif|png|webp)(?:\?|$)/.test(entry.name)) {
                    sum.imageEntries.push(entry);
                    return sum;
                }
                return sum;
            }, {
                cssEntries: [],
                jsEntries: [],
                imageEntries: [],
            });
            const sizes = {
                html: sumResourceSizes(navigationEntries),
                css: sumResourceSizes(cssEntries),
                js: sumResourceSizes(jsEntries),
                images: sumResourceSizes(imageEntries),
            };
            /* eslint-disable-next-line no-restricted-syntax */
            for (const resourceType of Object.keys(sizes)) {
                const sizesForTypes = sizes[resourceType];
                /* eslint-disable-next-line no-restricted-syntax */
                for (const sizeType of Object.keys(sizesForTypes)) {
                    const size = sizesForTypes[sizeType];
                    // This branch will be triggered in Firefox, Safari, IE...
                    // + also avoid sending `0` values to CMAG to avoid metrics skewed by cache hits
                    if (!size) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }
                    callback({ name: `page-${resourceType}-${sizeType}`, value: size });
                }
            }
        }
    });
};
//# sourceMappingURL=resource-size.js.map